<template>
  <TabbedBox>
    <template v-slot:tablist>
      <Tab :first="true" tabid="tab-1">
        <i class="far fa-sack-dollar"></i> Overpayments
      </Tab>
    </template>
    <template v-slot:tabcontent>
      <TabPage :first="true" tabid="tab-1">

        <OverPaymentDataTable>
          <template v-slot:title>
            <h3>Overpayments List</h3>
          </template>
          <template v-slot:tools>
            
          </template>
        </OverPaymentDataTable>

      </TabPage>
    </template>
  </TabbedBox>
</template>

<script>
import OverPaymentDataTable from '@/modules/accounts/components/overPaymentDataTable'

export default {
  name: 'OverPaymentList',
  components: {
    OverPaymentDataTable
  },
  props: {
    filterType: String
  },
  computed: {
    title() {
      return this.$route.meta.title
    }
  },
  methods: {
  }
};
</script>
